import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL;

// Employer side
export const getEmployerJobs = async (token) => {
  return axios.get(`${BASE_URL}/api/jobs/employer/my-jobs`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const createJobPosting = async (jobData, token) => {
  return axios.post(`${BASE_URL}/api/jobs`, jobData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateJobPosting = async (jobId, jobData, token) => {
  return axios.put(`${BASE_URL}/api/jobs/${jobId}`, jobData, {
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const publishJob = async (jobId, token) => {
  return axios.post(`${BASE_URL}/api/jobs/${jobId}/publish`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
export const archiveJob = async (jobId, token) =>
  axios.post(`${BASE_URL}/api/jobs/${jobId}/archive`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const closeJob = async (jobId, token) =>
  axios.post(`${BASE_URL}/api/jobs/${jobId}/close`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const renewJob = async (jobId, token) =>
  axios.post(`${BASE_URL}/api/jobs/${jobId}/renew`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const repostJob = async (jobId, token) =>
  axios.post(`${BASE_URL}/api/jobs/${jobId}/repost`, {}, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getJobAnalytics = async (jobId, token) =>
  axios.get(`${BASE_URL}/api/jobs/${jobId}/analytics`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const updateJobRequirements = async (jobId, reqData, token) =>
  axios.put(`${BASE_URL}/api/jobs/${jobId}/requirements`, reqData, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getJobPreview = async (jobId, token) =>
  axios.get(`${BASE_URL}/api/jobs/${jobId}/preview`, {
    headers: { Authorization: `Bearer ${token}` }
  });

// candidate side
export const getAvailableJobs = async () => {
  return axios.get(`${BASE_URL}/api/jobs/available`);
};

// 2. Apply to a job
export const applyToJob = async (jobId, formData, token) => {
  return axios.post(`${BASE_URL}/api/jobs/${jobId}/apply`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      // Do NOT set "Content-Type" manually; axios will set the boundary.
    },
  });
};

// 3. Get job details (common route)
export const getJobDetails = async (jobId, token) => {
  return axios.get(`${BASE_URL}/api/jobs/${jobId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
};
